(function () {
  document.querySelectorAll('product-info').forEach(init);

  function init(productInfo) {
    var enquireEnabled = productInfo.dataset.enquireEnabled === 'true';
    if (!enquireEnabled) return;

    var sentinel = productInfo.dataset.enquireSentinel || 'Custom';
    var basePage = productInfo.dataset.enquirePage || '/pages/make-an-enquiry';
    var productTitle = productInfo.dataset.productTitle || '';
    var productPath = productInfo.dataset.url || window.location.pathname;

    var buyWrapper = productInfo.querySelector('[data-buy-buttons-wrapper]');
    var enquireCTA = productInfo.querySelector('[data-enquire-cta]');
    var enquireLink = productInfo.querySelector('[data-enquire-link]');

    if (!buyWrapper || !enquireCTA || !enquireLink) return;

    function readPairs() {
      var pairs = [];

      productInfo.querySelectorAll('variant-selects select.select__select').forEach(function (sel) {
        var match = sel.name && sel.name.match(/options\[(.+)\]/);
        var name = match ? match[1] : sel.name;
        if (name && sel.value) pairs.push({ name: name, value: sel.value });
      });

      productInfo.querySelectorAll('variant-selects fieldset').forEach(function (fs) {
        var legend = fs.querySelector('legend');
        if (!legend || !legend.firstChild) return;
        var name = (legend.firstChild.textContent || '').replace(':', '').trim();
        var checked = fs.querySelector('input:checked');
        var value = checked ? checked.value : null;
        if (name && value) pairs.push({ name: name, value: value });
      });

      productInfo.querySelectorAll('select[data-extra-option]').forEach(function (sel) {
        var match = sel.name && sel.name.match(/properties\[(.+)\]/);
        var name = match ? match[1] : sel.name;
        if (name && sel.value) pairs.push({ name: name, value: sel.value });
      });

      return pairs;
    }

    function buildEnquireUrl(pairs) {
      var params = new URLSearchParams();
      if (productTitle) params.set('product', productTitle);
      if (productPath) params.set('product_url', productPath);
      if (pairs.length) {
        params.set(
          'options',
          pairs
            .map(function (p) {
              return p.name + ':' + p.value;
            })
            .join('|')
        );
      }
      var qs = params.toString();
      return qs ? basePage + '?' + qs : basePage;
    }

    function update() {
      var pairs = readPairs();
      var hasSentinel = pairs.some(function (p) {
        return p.value === sentinel;
      });
      enquireCTA.toggleAttribute('hidden', !hasSentinel);
      buyWrapper.toggleAttribute('hidden', hasSentinel);
      enquireLink.setAttribute('href', buildEnquireUrl(pairs));
    }

    productInfo.addEventListener('change', function (e) {
      if (!e.target) return;
      var tag = e.target.tagName;
      if (tag !== 'SELECT' && tag !== 'INPUT') return;
      update();
    });

    update();
  }
})();
